import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdminComponent } from './admin.component';
import { UsersComponent } from './users/users.component';
import { SuperviseurGuardService } from '../common/guards/superviseur-guard.service';
import { AuthenticatedGuardService } from '../common/guards/authenticated-guard.service';
import { EntitesComponent } from './entites/entites.component';


const routes: Routes = [
  {
    path: '',
    component: AdminComponent,
    children: [
      {
        path: '',
        redirectTo: 'users',
        pathMatch: 'full',
      },
      { path: 'users', component: UsersComponent , canActivate: [AuthenticatedGuardService, SuperviseurGuardService ]},
      { path: 'entites', component: EntitesComponent , canActivate: [AuthenticatedGuardService, SuperviseurGuardService ]},
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AdminRoutingModule {

}
